import { render, staticRenderFns } from "./printparents.vue?vue&type=template&id=4ba96266&scoped=true&"
import script from "./printparents.vue?vue&type=script&lang=js&"
export * from "./printparents.vue?vue&type=script&lang=js&"
import style0 from "./printparents.vue?vue&type=style&index=0&id=4ba96266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba96266",
  null
  
)

export default component.exports